var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bold / Essentional, UI / Close Circle",
    clipPath: "url(#clip0_2768_23827)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1",
    opacity: 0.1,
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#E31837"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2",
    cx: 59.5,
    cy: 60.5,
    r: 37.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110 60C110 87.6142 87.6142 110 60 110C32.3858 110 10 87.6142 10 60C10 32.3858 32.3858 10 60 10C87.6142 10 110 32.3858 110 60ZM44.8481 44.8482C46.3126 43.3838 48.687 43.3838 50.1514 44.8482L59.9998 54.6967L69.8481 44.8484C71.3126 43.3839 73.687 43.3839 75.1514 44.8484C76.6159 46.3128 76.6159 48.6872 75.1514 50.1517L65.3031 60L75.1513 69.8481C76.6158 71.3126 76.6158 73.687 75.1513 75.1515C73.6869 76.6159 71.3125 76.6159 69.848 75.1515L59.9998 65.3033L50.1516 75.1516C48.6871 76.616 46.3127 76.616 44.8482 75.1516C43.3838 73.6871 43.3838 71.3127 44.8482 69.8483L54.6965 60L44.8481 50.1516C43.3837 48.6871 43.3837 46.3127 44.8481 44.8482Z",
    fill: "#E31837"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2768_23827"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.53b35141f1deb0680d6baecc825e9805.svg";
export { ForwardRef as ReactComponent };